import {IRoutingState, RoutingActions} from "./types";
import {Reducer} from "redux";
import {getType} from "typesafe-actions";
import * as actions from "./actions";

const initialState: IRoutingState = {
    isLoading: false,
    isError: false
};

export const routingReducer : Reducer<IRoutingState, RoutingActions> = (state = initialState, action) => {
    switch (action.type) {
        case getType(actions.loadScene.request):
            return {
                ...state,
                isLoading: true,
                isError: false,
            };

        case getType(actions.loadScene.success):
            return {
                ...state,
                isLoading: false,
                previousScene: state.scene,
                scene: action.payload,
            };

        case getType(actions.loadScene.failure):
            return {
                ...state,
                isError: true,
                isLoading: false,
            };

        default:
            return state;
    }
};
